<template>
  <li>
    <div class="text">
      <span
        v-if="props.address.bscDlvdesYn === 'Y'"
        class="c-round-flag type-primary type-small"
      >
        기본배송지
      </span>
      <p class="name">
        {{ props.address.dlvdesNm || "-" }}({{ props.address.acptrNm }})
      </p>
      <p class="address">
        ({{ props.address.zip }})<br />
        {{ props.address.roadNmBscAddr }} {{ props.address.roadNmDtlAddr }}
      </p>
      <p class="phone">
        {{ props.address.acptrWrdTelno }} / {{ props.address.acptrMblTelno }}
      </p>
    </div>
    <div v-if="props.address.bscDlvdesYn === 'N'" class="c-btn-area type-full">
      <button
        type="button"
        class="c-util-button type-line-black"
        @click="() => emits('edit', props.address)"
      >
        <span class="bold">수정</span>
      </button>
      <button
        type="button"
        class="c-util-button type-line-black"
        @click="() => emits('delete', props.address)"
      >
        <span class="bold">삭제</span>
      </button>
    </div>
  </li>
</template>
<script setup>
import { onMounted, defineProps, defineEmits } from "vue";

const props = defineProps({
  address: {
    type: Object,
    required: true,
  },
});

const emits = defineEmits(["edit", "delete"]);

onMounted(() => {});
</script>
